// Copyright 2021 Sorama B.V.

import { autoinject } from "aurelia-framework";
import { SettingsModal } from "modules/modals/SettingsModal";
import { NearfieldModule } from "modules/workflows/Analysis/Nearfield/NearfieldModule";

@autoinject
export class NearfieldSettingsModal extends SettingsModal<NearfieldModule> {}
